import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
// @ts-expect-error untyped import
import useMediaQuery from '../../hooks/useMediaQuery';
import { device } from '../../constants/StyledComponentConstants';
import { FormattedMessage } from 'LearningCenterUI/components/I18n';
import ReducedContentCard from '../ContentCards/ReducedContentCard/ReducedContentCard';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIBox from 'UIComponents/layout/UIBox';
import { GREAT_WHITE } from 'HubStyleTokens/colors';
import UsageTracker from '../../utils/UsageTracker'; // @ts-expect-error untyped import

import ResponsiveCardGridContainer from '../ResponsiveCardGridContainer';
import { useProgressAssetsByStatus } from '../../features/userProgress';
import SectionHeading from '../SectionHeading';
import { RouterLink } from '../AcademyLinks';
import styled, { css, mediaQuery } from '../../utils/Styling';
import { useAllLessons } from '../../features/lessons';
import { useAllTracks } from '../../features/tracks';
import { useMemo } from 'react';
const InProgressContainer = styled.div.withConfig({
  displayName: "InProgressSection__InProgressContainer",
  componentId: "sc-14u6s05-0"
})(["padding:35px 0 40px;border-bottom:1px solid ", ";@media screen and ", "{padding:16px 0 20px;}"], GREAT_WHITE, device.mobile);
const PaddedRouterLink = styled(RouterLink).withConfig({
  displayName: "InProgressSection__PaddedRouterLink",
  componentId: "sc-14u6s05-1"
})(["padding:12px 0;"]);
const HeaderContainer = styled(UIFlex).withConfig({
  displayName: "InProgressSection__HeaderContainer",
  componentId: "sc-14u6s05-2"
})(["margin-bottom:16px;", ""], mediaQuery('mobile', css(["margin-bottom:8px;"])));
const CardBox = styled.div.withConfig({
  displayName: "InProgressSection__CardBox",
  componentId: "sc-14u6s05-3"
})(["width:100%;padding:4px 0;&:not(:last-child){@media screen and ", "{margin-right:32px;flex-basis:auto;}}"], device.mobile);

const InProgressSection = () => {
  const isMobile = useMediaQuery(`screen and ${device.mobile}`);
  const {
    assets
  } = useProgressAssetsByStatus({
    status: 'IN_PROGRESS',
    context: 'INDIVIDUAL'
  });

  const trackViewAllClick = () => UsageTracker.track('interaction', {
    action: 'in-progress-view-all-clicked'
  });

  const renderViewAllLink = () => {
    const linkCopy = isMobile ? 'seeAll' : 'viewAll';
    return /*#__PURE__*/_jsx(PaddedRouterLink, {
      onClick: trackViewAllClick,
      to: "/mylearning/in-progress?sortBy=RECENTLY_ACCESSED",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `learningCenter.inProgressSection.${linkCopy}`
      })
    });
  };

  const {
    allLessons,
    allLessonsLoading
  } = useAllLessons();
  const {
    allTracks,
    allTracksLoading
  } = useAllTracks();
  const filteredAssets = useMemo(() => {
    if (allLessonsLoading || allTracksLoading) return assets;
    return assets.filter(asset => {
      if (asset.type === 'PLAYLIST') return true;
      return asset.type === 'LESSON' ? allLessons[asset.id] : allTracks[asset.id];
    }).sort((a, b) => b.updatedAt - a.updatedAt);
  }, [allLessons, allLessonsLoading, allTracks, allTracksLoading, assets]);
  return filteredAssets && filteredAssets.length > 0 ? /*#__PURE__*/_jsxs(InProgressContainer, {
    children: [/*#__PURE__*/_jsxs(HeaderContainer, {
      align: 'center',
      children: [/*#__PURE__*/_jsx(UIBox, {
        grow: 2,
        children: /*#__PURE__*/_jsx(SectionHeading, {
          className: "m-bottom-0",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.inProgressSection.sectionTitle"
          })
        })
      }), /*#__PURE__*/_jsx(UIBox, {
        children: filteredAssets.length > 3 && renderViewAllLink()
      })]
    }), /*#__PURE__*/_jsx(ResponsiveCardGridContainer, {
      className: 'noBorder noPadding',
      columnSize: 250,
      columns: 3,
      nowrap: true,
      children: filteredAssets.slice(0, 3).map((content, index) => {
        let contentType = 'lesson';

        if (content.type === 'LESSON') {
          contentType = 'lesson';
        } else if (content.type === 'TRACK') {
          contentType = 'track';
        } else if (content.type === 'PLAYLIST') {
          contentType = 'playlist';
        }

        return content ? /*#__PURE__*/_jsx(CardBox, {
          children: /*#__PURE__*/_jsx(ReducedContentCard, {
            appearsIn: "in-progress",
            contentId: content.id,
            contentType: contentType,
            language: content.language || undefined,
            position: index + 1
          })
        }, content.id) : null;
      })
    })]
  }) : null;
};

export default InProgressSection;